import React from "react";
import EmailSvg from "material-ui/svg-icons/communication/email";
import MessageSvg from "material-ui/svg-icons/communication/message";
import SmsMessageSvg from "material-ui/svg-icons/notification/sms";
import ModeEditSvg from "material-ui/svg-icons/editor/mode-edit";
import PrintSvg from "material-ui/svg-icons/action/print";
import EventNoteSvg from "material-ui/svg-icons/notification/event-note";
import AddSvg from "material-ui/svg-icons/content/add";
import SendSvg from "material-ui/svg-icons/content/send";
import CloseSvg from "material-ui/svg-icons/navigation/close";
import {grey400} from "material-ui/styles/colors";


export const Email = () => (<EmailSvg color={grey400}/>);
export const Edit = () => (<ModeEditSvg color={grey400}/>);
export const Print = () => (<PrintSvg color={grey400}/>);
export const EventNote = () => (<EventNoteSvg color={grey400}/>);
export const Add = () => (<AddSvg color={grey400}/>);
export const Close = () => (<CloseSvg color={grey400}/>);
export const Message = () => (<MessageSvg color={grey400}/>);
export const Send = () => (<SendSvg color={grey400}/>);
export const SmsMessage = () => (<SmsMessageSvg color={grey400}/>);




// WEBPACK FOOTER //
// ./src/core/components/buttons/svgIcons.tsx